/**
 * Creates a theme function
 *
 * @class
 */

var Theme = function(theme, target){
    switch(theme){
        case "dark":
            $(target).addClass('editor--dark');
            break;
        case "white":
            $(target).addClass('editor--white');
            break;
    }
}

module.exports = Theme;